import React from 'react'

import Button from '@react/react-spectrum/Button'
import { Card, CardCoverPhoto, CardBody, CardFooter } from '@react/react-spectrum/Card'
import ModalTrigger from '@react/react-spectrum/ModalTrigger'

import Clock from '@react/react-spectrum/Icon/Clock'
import Delete from '@react/react-spectrum/Icon/Delete'
import Duplicate from '@react/react-spectrum/Icon/Duplicate'
import Gears from '@react/react-spectrum/Icon/Gears'
import UsersShare from '@react/react-spectrum/Icon/UsersShare'

import { DuplicateProjectDialog } from 'components/DuplicateProject'
import { ShareProjectDialog } from 'components/ShareProject/ShareProject'

import ProjectTypeIcon from 'components/ProjectTypeIcon'
import { DeleteProjectDialog } from 'components/DeleteProject'
import { getConfig, deleteLaunchProperty, deleteDataStream } from 'services/project'
import { fromNow } from 'utils/datetime'

export default ({
  projects,
  variant = 'regular',
  projectClickHandler,
  projectDeleteHandler,
  projectDuplicateHandler,
}) =>
  projects.map((project) => (
    <ProjectCard
      key={project?.meta?.id}
      propertyID={project?.integrations?.launch?.propertyID}
      variant={variant}
      project={project}
      onClick={projectClickHandler(project)}
      onEdit={projectClickHandler(project)}
      onDelete={projectDeleteHandler(project)}
      onDuplicate={projectDuplicateHandler(project)}
    />
  ))

export const ProjectCard = ({ project, variant, onClick, onEdit, onDelete, onDuplicate, propertyID }) => {
  const cardClass = 'projectCard' + (variant === 'small' ? 'Small' : '')
  const canDelete = typeof onDelete === 'function'
  const config = getConfig(project.meta.type)

  const handleDeleteSubmit = async (deleteTags) => {
    if (canDelete) {
      onDelete(project?.meta?.id)
    }
    if (deleteTags && propertyID) {
      await deleteDataStream(project?.integrations?.launch?.id)
      deleteLaunchProperty(project?.integrations?.launch?.id)
    }
  }

  return (
    <Card allowsSelection={false} onClick={onClick} className={cardClass}>
      <CardCoverPhoto src={project.meta.thumbnail}>
        <div className={cardClass + '__actions'} onClick={(e) => e.stopPropagation()}>
          <ModalTrigger>
            <Button variant='tool' icon={<UsersShare />} aria-label='Share' />
            <ShareProjectDialog project={project} projectConfig={config} />
          </ModalTrigger>
          <Button variant='tool' icon={<Gears />} aria-label='Edit' onClick={onEdit} />
          <ModalTrigger>
            <Button variant='tool' icon={<Duplicate />} aria-label='Duplicate' />
            <DuplicateProjectDialog
              projectId={project?.meta?.id}
              title={project.meta.title + ' Copy'}
              drNumber=''
              onSubmit={onDuplicate}
            />
          </ModalTrigger>
          {canDelete && (
            <ModalTrigger>
              <Button variant='tool' icon={<Delete />} aria-label='Delete' />
              <DeleteProjectDialog
                projectId={project?.meta?.id}
                title={project.meta.title}
                drNumber=''
                onSubmit={handleDeleteSubmit}
                propertyID={propertyID}
              />
            </ModalTrigger>
          )}
        </div>
      </CardCoverPhoto>
      <CardBody title={project.meta.title} subtitle={project?.meta?.id}></CardBody>
      <CardFooter className='project-card-footer'>
        <Clock size='XS' />
        <span>
          {fromNow(project.updatedAt)} by {project.updatedBy || project.owner}
        </span>
        <ProjectTypeIcon icon={project.meta.typeIcon} projectType={project.meta.type} />
      </CardFooter>
    </Card>
  )
}
